import createAxios from "@/_services/axiosHttp";

export const ANALYTICS_INTERVALS = Object.freeze([
  "today",
  "this_month",
  "this_quarter",
  "this_four_month_period",
  "this_year",
  "last_year",
]);

export async function getAnalytics(interval = "this_month") {
  const axios = createAxios();
  return axios.get("ttmm/analytics", { params: { interval } });
}
